export default __webpack_public_path__ + "lower_arm.f4b98b9f.png";